


























import {
  defineComponent,
  computed,
} from '@vue/composition-api';
import store from '@/store';

export default defineComponent({
  name: 'TempAmount',
  setup() {
    /** 渠道信息 */
    const channel = computed(() => store.state.applyProduct.channel);
    /** 渠道额度调整信息 */
    const adjustQuota = computed(() => channel.value?.adjustQuota);

    /** 是否在优惠模块中展示临时额度（实验命中 + 有临额） */
    const showTempAmount = computed(
      () => store.getters['applyProduct/showTempAmountInDiscountModule'] as boolean,
    );

    /** 是否展示提额入口（优惠模块场景，有无临额都可能展示） */
    const shouldShowTempAmountEntry = computed(
      () => store.getters['applyProduct/shouldShowTempAmountEntry'] as boolean,
    );

    /** 临额有效期 */
    const tempCreditExpiryTime = computed(() => adjustQuota.value?.tempCreditExpiryTime || '');
    /** 临额金额 */
    const adjustValue = computed(() => adjustQuota.value?.adjustValue || 0);

    /** 点击提额入口 */
    const handleApplyTempAmount = () => {
      store.dispatch('applyProduct/applyTempAmountEntry');
    };

    return {
      tempCreditExpiryTime,
      adjustValue,
      showTempAmount,
      shouldShowTempAmountEntry,
      handleApplyTempAmount,
    };
  },
});
